import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
import { Photos, Wrapper as GalleryWrapper } from '@spa/shared/components/Search/Card/Gallery/styles';
import { WrapperLink, Title as OfferCardTitle, Price, BillsIncluded } from '@spa/shared/components/Search/Card/OfferCard/styles';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1pxl8eg-0"
})(["display:flex;flex-direction:column;gap:", ";margin-top:", ";", " ", "{width:224px;", "{display:none;}", "{margin-bottom:", ";}", "{height:160px;}", "{span{margin-left:0;}}", "{color:", ";}}"], function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(7);
}, mediaMin.smallBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    ", "\n  "])), function (props) {
  return props.theme.space(3);
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(3, 'column');
}), WrapperLink, OfferCardTitle, GalleryWrapper, function (props) {
  return props.theme.space(2);
}, Photos, Price, BillsIncluded, function (props) {
  return props.theme.landlordSection.card.billsIncludedColor;
});